<template>
  <div>
    <b-row class="mt-2">
      <!-- <b-col>
        <customer-information
          :value.sync="value"
          :readonly="readonly"
          ref="LCLBookingSaleCustomer"
        />
      </b-col> -->
    </b-row>
    <b-row class="mt-2">
      <b-col cols="12" md="8">
        <routing-detail
          :value.sync="value"
          :readonly="readonly"
          ref="Routing"
        />
      </b-col>
      <b-col cols="12" md="4">
        <sailing-schedule
          :value.sync="value"
          :readonly="readonly"
          ref="Sailing"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-2">
        <cargo-details :value.sync="value" :readonly="readonly" ref="Cargo" />
      </b-col>
    </b-row>
    <b-row class="mt-8">
      <b-col cols="4" md="3">
        <freight-terms :value.sync="value" :readonly="readonly" ref="freight" />
      </b-col>
      <b-col cols="8" md="9">
        <remarkable :value.sync="value" :readonly="readonly" />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <additional-service
          :value.sync="value"
          :readonly="readonly"
          cols="12"
        ></additional-service>
      </b-col>
    </b-row>
    <b-row class="mt-15">
      <b-col>
        <notes :value.sync="value" :readonly="readonly" cols="12"></notes>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <attach-files
          :value.sync="value"
          :readonly="readonly"
          cols="12"
          ref="AttachFile"
        ></attach-files>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="value.status_id && value.status_id != 5 && value.status_id !=6">
            <ChatWithWR1
              :request_quotation="value"
              :isCustomer="true"
            />
        </b-row>
  </div>
</template>

<script>
import CustomerInformation from "./components/CustomerInformation.vue";
import RoutingDetail from "./components/RoutingDetail.vue";
import SailingSchedule from "./components/SailingSchedule.vue";
import CargoDetails from "./components/CargoDetails.vue";
import FreightTerms from "./components/FreightTerms.vue";
import Remarkable from "./components/Remarkable.vue";
import AdditionalService from "./components/AdditionalService.vue";
import Notes from "./components/Notes.vue";
import AttachFiles from "./components/AttachFiles.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ChatWithWR1 from '../../quotation/ChatWithWR1.vue'
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomerInformation,
    RoutingDetail,
    SailingSchedule,
    CargoDetails,
    FreightTerms,
    Remarkable,
    AdditionalService,
    Notes,
    AttachFiles,
    ChatWithWR1,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),

    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
.custom_list_btn {
  justify-content: end;
  gap: 20px;
  display: flex;
  margin-right: 0px;
}
.mt-8 {
  margin-top: 80px !important;
}
.mt-15 {
  margin-top: 120px !important;
  @media (max-width: 992px) {
    margin-top: 220px !important;
  }
}
</style>
